<template>
  <div class="about">
    <!-- 新版用户使用协议及隐私政策 -->
    <div class="top">
      <p>以下内容是《中文知识网使用协议》及《中文知识网隐私政策》，在您注册中文知识网前请务必审慎阅读、充分理解协议中相关条款内容。</p>
      <p>《中文知识网使用协议》包括接受条款；服务内容；账户及安全；担保与保证；用户使用规范；知识产权；权益保护；用户隐私政策；服务变更、中断或终止；国际使用之特别告知；未成年人使用条款；服务条款的修改和服务修订；一般条款。</p>
      <p>《中文知识网隐私政策》包括我们如何收集和使用您的个人信息；我们如何使用Cookie；我们如何共享、转让、公开披露您的个人信息；我们如何保护您的个人信息；您的权利 ；本政策如何更新；如何联系我们。</p>
      <p>您一旦注册中文知识网，即视为您已了解并同意《中文知识网使用协议》及《中文知识网隐私政策》的各项内容。</p>
      <p class="overstriking">请您务必审慎阅读、充分理解协议中相关条款内容，特别是粗体标注的内容。您一旦注册中文知识网，即视为您已了解并完全同意本协议各项内容，包括中文知识网对使用协议随时所做的任何修改。如您不同意本协议及/或随时对其的修改，请您立即停止注册及使用中文知识网所提供的全部服务。</p>
    </div>
    <div class="h">
      <h2>中文知识网使用协议</h2>
    </div>
    <ul class="conent">
      <li>
        <h3>1.接受条款</h3>
        <p>1.1 中文知识网（在本协议中是指中文知识网及其子网站、客户端及对网站享有所有权和运营权的主体）根据本使用协议的条款及发布的规则为您提供基于中文知识网的互联网以及移动互联网的相关服务。</p>
        <p>1.2 如您按照注册页面的提示填写信息、阅读并点击同意本协议，完成全部注册流程，即成为中文知识网用户（以下简称“用户”或“您”），并受本协议的约束，本协议即在用户与中文知识网之间产生法律效力，成为对双方均具有约束力的法律文件。</p>
        <p>1.3 本协议是用户与中文知识网关于使用中文知识网网络服务所订立的协议，适用网络服务包括中文知识网提供的测试及正式发布的全部网络服务。用户使用中文知识网单项服务时，应遵守中文知识网因法律法规变化、业务发展需求发布的与该服务相关的指引和规则。前述所有的指引和规则，均构成本使用协议的一部分。</p>
        <p>1.4 用户应遵守本协议的各项条款，合法合理使用中文知识网提供的服务，否则，中文知识网有权依据本协议中断或终止网络服务。</p>
      </li>
      <li>
        <h3>2.服务内容</h3>
        <p>2.1 中文知识网向用户提供包括但不限于如下服务：检索并查阅文章题录信息和全文；下载全文；付费内容服务等。除非本协议另有其它明示规定，中文知识网增加或强化目前本服务的任何新功能，包括所推出的新产品，均受本使用协议之规范。</p>
        <p>2.2 用户了解并同意，中文知识网之服务、产品与资料仅依其当前所呈现的状况提供，而且<span>中文知识网明确地表示拒绝对于“服务”、“资料”或“产品”等给予任何明示或暗示之担保或保证，包括但不限于，为商业使用、适合于特定目的或未侵害他人权利之担保或保证等。</span>中文知识网对于因“服务”、“产品”或“资料”等所产生之任何直接、间接、附带的或因此而导致之衍生性损失概不负责。中文知识网对于任何用户信息或个性化设定之时效、删除、传递错误、未予储存或其它任何问题，均不承担任何责任。</p>
        <p>2.3 <span>同意中文知识网有权制订关于使用本服务的一般措施及限制。</span>您也同意，中文知识网有权依其自行之考虑，不论通知与否，随时变更这些一般措施及限制。</p>
        <p>2.4 您同意中文知识网提供的网络服务中包含部分收费的服务，对于收费服务，中文知识网将在用户使用前给予明确提示，只有用户确认愿意支付费用后才能使用该服务。</p>
      </li>
      <li>
        <h3>3.账户及安全</h3>
        <p>3.1 账户注册</p>
        <p>3.1.1 用户使用中文知识网网络服务的部分功能前，需要拥有一个成功注册的账户，用户可以使用真实有效的个人手机号码作为用户名进行账户注册。</p>
        <p>3.1.2 用户使用中文知识网部分网络服务时，或需提供用户个人的实名信息，故提请用户妥善保管个人账户名及密码。账户名称和密码将作为中文知识网识别用户身份的唯一有效标识。用户可通过中文知识网的“找回密码”服务进行密码重置操作。</p>
        <p>3.1.3 成功注册/登录后用户可进入“我的账户”修改个人信息。一般情况下，您可随时浏览、修改您在中文知识网上的信息，但出于安全性和身份识别的考虑，您可能无法修改注册时提供的初始注册信息。</p>
        <p>3.1.4 为了您能更好的使用中文知识网的各项网络服务，保障您的账户安全，中文知识网可要求您按照我国法律规定完成实名认证。</p>
        <p>3.2 账户安全</p>
        <p>3.2.1 完成本服务的注册程序并成功注册之后，您可使用您的手机号码和密码，登录到您在中文知识网的账号（下称“账号”）。注册完成之时，您便获得了账号的使用权。保护账号安全，是您的责任。</p>
        <p>3.2.2 用户对个人账户的使用、遗失等造成的任何中文知识网及第三方的损失，由用户承担；若发现您的中文知识网账号遭到未获授权的使用，或者发生存在其它安全问题，请立即联系中文知识网。</p>
        <p>3.2.3 中文知识网将通过对用户密码进行加密等安全措施确保用户的信息不丢失，不被滥用和变造。尽管有前述安全措施，用户理解在信息网络上不存在“完善的安全措施”。<span>因黑客行为或您的保管疏忽导致账号、密码遭他人非法使用，中文知识网不承担任何责任。如用户发现任何非法使用用户账户或存在安全漏洞的情况，应立即通知中文知识网。</span></p>
      </li>
      <li>
        <h3>4.担保与保证</h3>
        <p><span>4.1中文知识网不保证以下事项∶</span></p>
        <p><span>• 本服务将符合您的要求；</span></p>
        <p><span>• 本服务将不受干扰、及时提供、安全可靠或不会出错；</span></p>
        <p><span>• 使用本服务取得之结果正确可靠；</span></p>
        <p><span>• 您经由本服务购买或取得之任何产品、服务、资讯或其它信息将符合您的期望；</span></p>
        <p><span>4.2是否使用本服务下载或取得任何资料应由您自行考虑且自负风险，因任何资料之下载而导致的您电脑系统之任何损坏或数据丢失等后果，由您自行承担；</span></p>
        <p>4.3您自中文知识网或经由本服务取得的任何建议或信息，无论是书面或口头形式，除非本使用协议有明确规定，将不构成本使用协议以外之任何保证。</p>
      </li>
      <li>
        <h3>5.用户使用规范</h3>
        <p>5.1对中文知识网拥有知识产权的内容，中文知识网仅授予您个人、不可移转及非专属之使用权，使您得于在单机计算机上使用其软件之目的，但您不得（且不得允许任何第三人）复制、修改、改编、翻译、创作衍生著作、进行还原工程、反向组译、传播或以其它方式发现原始码，或出售、转让、再授权或提供软件设定担保，或以其它方式移转软件之任何权利。</p>
        <p>您在使用中文知识网网络服务过程中不得出现以下行为：</p>
        <p>1）对中文知识网中的内容进行出租、出借、转载、发表、出版；</p>
        <p>2）建立中文知识网镜像站点；</p>
        <p>3）对网络服务的程序、图像、文档进行还原、反编译、反汇编和改编等任何修改行为；</p>
        <p>4）对网络服务进行反向工程、反向编译或反汇编等任何技术性的与合理使用网络服务无关的行为或者以其他方式尝试发现本网络服务的源代码；</p>
        <p>5）使用非中文知识网开发或授权的第三方软件、插件、外挂、系统，登录或使用中文知识网网络服务。</p>
        <p>5.2您在发现安全弱点和可疑事件时及时向安全管理部门报告，不应私自尝试验证安全弱点。</p>
      </li>
      <li>
        <h3>6.知识产权</h3>
        <p>6.1 中文知识网在本服务中提供的内容（包括但不限于网页、界面设计、版面框架、文字、音频、视频、图片或其他资料等）等知识产权归中文知识网或相关权利人所有。除另有说明外，中文知识网提供本服务时所依托的软件、系统等的著作权、专利权及其他知识产权归中文知识网所有。</p>
        <p>6.2 中文知识网以及其他中文知识网标识及产品、服务名称，均为中文知识网之商标。未经中文知识网事先书面同意，您不得擅自删除、掩盖或更改中文知识网的版权声明、商标或其它权利声明，不得将中文知识网的商标以任何方式展示或使用或作其它处理，或表示您有权展示、使用或另行处理中文知识网的商标。</p>
        <p>6.3 您了解并同意，本服务及本服务所使用之相关软件含有受到相关知识产权及其他法律保护之专有保密资料。您也了解并同意，经由本服务或广告商向您呈现之赞助广告或信息所包含之内容，亦受到著作权、商标权、专利权或其他专属权利之法律保护。未经中文知识网或广告商明示授权，您不得修改、出租、出借、出售、散布本服务或软件之任何部分或全部，或据以制作衍生著作，或使用擅自修改后的软件等。您同意将通过由中文知识网所提供的界面而非任何其它途径使用本服务。</p>
        <p>6.4 如您违反世界版权公约、中华人民共和国著作权法、商标法、专利法、反不正当竞争法及其他与知识产权方面相关的法律法规或本协议约定，您应自行承担因此而给他人（包括中文知识网）造成的损害，并承担相应的法律责任。</p>
      </li>
      <li>
        <h3>7.权益保护</h3>
        <p>中文知识网尊重他人合法权益（包括知识产权、名誉权、商誉权等），您也需尊重他人合法权益。如果您违反法律法规的禁止性规定、对他人的合法权益或公众利益造成了侵害，中文知识网将依国家法律法规的规定，或在适当的情形下，依本协议或其相关规定，删除特定内容或以至终止您对账户的使用。</p>
      </li>
      <li>
        <h3>8.用户隐私政策</h3>
        <p>保护您个人信息安全既是法律要求，也是中文知识网长期坚持的一项基本原则。您提供的注册资料及中文知识网保留的有关您的其它资料将受到中国有关法律的保护。中文知识网将根据中国法律、本协议、《中文知识网隐私政策》的规定收集、存储、使用和透露您的个人信息。</p>
      </li>
      <li>
        <h3>9.服务变更、中断或终止</h3>
        <p>9.1 中文知识网可能会对服务内容进行变更、也可能会中断、终止服务。</p>
        <p>9.2 鉴于网络服务的特殊性（包括但不限于服务器的稳定性问题、恶意的网络攻击等行为或中文知识网无法控制的情形），您同意中文知识网有权随时中断或终止部分或全部的服务。</p>
        <p>9.3 您理解，中文知识网需要定期或不定期对提供服务的平台或相关设备进行维护、升级或其他目的暂停部分或全部服务，如因此类情况而造成服务在合理时间内的中断，中文知识网无需为此承担任何责任。</p>
        <p>9.4 如发生以下任何一种情形，中文知识网有权随时中断或终止向您提供本协议项下的服务而无需对您或任何第三方承担责任：</p>
        <p>1）您提供个人资料不真实；</p>
        <p>2）您违反法律、政策或违反本使用协议。</p>
        <p>9.5 您同意中文知识网基于其自行之考虑，包含但不限于缺乏使用，或中文知识网认为您已经违反本使用协议，终止您的账号或本服务之使用（或服务之任何部分），并将您在本服务内任何内容加以移除并删除。您同意依本使用协议任何规定提供之服务，无需进行事先通知即可中断或终止。您承认并同意，中文知识网可立即关闭或注销您的账号及删除您账号中所有相关信息及文件，及/或禁止继续使用前述文件或本服务。此外，您同意若本服务之使用被中断或终止或您的账号及相关信息和文件被关闭或注销，中文知识网对您或任何第三人均不承担任何责任。</p>
        <p>9.6 用户对网络服务的使用承担风险。本服务系统对此不作任何类型的担保，不论是明确的或隐含的。本服务系统无法保证服务不会中断，对服务的及时性、安全性、出错发生都不作保证。</p>
        <p>9.7 因不可抗力或中文知识网不能控制的原因造成的网络服务中断或其它问题，中文知识网不承担任何责任。</p>
        <p>9.8 中文知识网不保证提供的网络服务中可能存在的外部链接的准确性和完整性，同时对于该等外部链接指向的任何链接上的内容，中文知识网不承担任何责任。</p>
        <p>9.9 用户理解并同意，中文知识网会尽力保障用户使用数据的存储安全，但不能就此完全保证，包括但不限于以下情形：</p>
        <p>9.9.1 中文知识网有权根据实际情况自行决定用户在中文知识网上使用数据的最长存储期限和最大存储空间等，用户可自行根据自己的需要备份您在中文知识网的使用数据。</p>
        <p>9.9.2 由于网络信号不稳定、网络带宽小等原因导致登录、注册、资料同步、内容查看不稳定、收费服务在合理时间内中断的，其风险由用户自行承担。</p>
        <p><span>9.9.3 如果用户删除了中文知识网账户，我们有权从服务器中永久删除用户的账户数据，且没有义务向用户返还数据。</span></p>
      </li>
      <li>
        <h3>10.国际使用之特别告知</h3>
        <p>您已了解互联网的无国界性，同意遵守当地所有关于网上行为及内容之法律法规。您特别同意遵守有关从中国或您所在国家或地区输出信息之传输的所有适用法律法规。</p>
      </li>
      <li>
        <h3>11.未成年人使用条款</h3>
        <p>如您是未成年用户，请在法定监护人的陪同下仔细阅读本使用协议，您及法定监护人应按照法律及本协议规定承担责任。</p>
      </li>
      <li>
        <h3>12.服务条款的修改和服务修订</h3>
        <p>12.1 中文知识网有权在必要时修改服务条款，如果您不同意所改动的内容，您应当立即主动取消获得的网络服务。如果您继续享用网络服务，则视为接受服务条款的变动。</p>
        <p>12.2 除对本协议的直接修改，中文知识网针对某些特定的中文知识网网络服务的使用通过各种方式（包括但不限于网页公告、电子邮件、短信提醒等）作出的任何声明、通知、警示等内容视为本协议的一部分，您如使用该等中文知识网网络服务，视为您同意该等声明、通知、警示的内容。</p>
      </li>
      <li>
        <h3>13.一般条款</h3>
        <p>13.1 中文知识网公布的《中文知识网隐私政策》均是本协议的有效组成部分，本协议及与中文知识网服务相关的指引和规则共同规范您对于本服务之使用行为。在您使用相关服务、使用第三方提供的内容或软件时，亦应遵从所适用之附加条款及条件。</p>
        <p>13.2 本使用协议及您与中文知识网之关系，均适用中华人民共和国法律。您与中文知识网就本服务、本使用协议或其他有关事项发生的争议，应首先友好协商解决，协商不成时应提请中文知识网实际运营者所在地有管辖权的人民法院通过诉讼解决。</p>
        <p>13.3 中文知识网未行使或执行本使用协议任何权利或规定，不构成对前述权利或权利之放弃。</p>
        <p>13.4 倘若本使用协议之任何规定因与中华人民共和国法律抵触而无效，本使用协议其他规定仍应具有完整的效力及效果。</p>
        <p>13.5 本使用协议之标题仅供方便而设，不具任何法律或契约效果。</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      content:''
    }
  },
  methods:{
    async created() {
      let res = await this.$apis.loginServe.getPrivacy();
      this.content = res.content.detail[0].content;
    },
  },
  mounted() {
    document.title = '使用协议'
    this.created()
  }
};
</script>

<style scoped lang="scss">
.about {
  margin: 0 auto;
  padding: 50px;
  width: 1200px;
  min-height: 840px;
  background: #ffffff;
  border: 1px solid #a3cbe7;
  border-radius: 10px;
  font-size: 15px;
  color: #333;
  line-height: 30px;
  & .top{
    & p{
      text-indent: 30px;
    }
    & .overstriking{
      font-weight: bold;
      font-size: 17px;
    }
  }
  & .h{
    text-align: center;
    margin-top: 50px;
  }
  & .conent{
    & li{
      margin-top: 40px;
      & h2{
        font-weight: bold;
        margin-bottom: 10px;
      }
      & p{
        text-indent: 30px;
        & span{
          font-weight: bold;
          font-size: 15px;
          font-family:  Microsoft YaHei;
        }
      }
    }
  }
}
/* h3 {
  font-size: 18px;
  font-family: PingFangSC-Regular;
  color: #333333;
  text-align: center;
}
h4{
  color: #333;
  font-size: 15px;
}
ul li p{
  font-size: 14px;
}
ul li{
  margin-top: 30px;
  line-height: 30px;
}
.but{
  width: 150px;
  height: 40px;
  margin: 0 auto;
  line-height: 40px;
  text-align: center;
  color: #fff;
  background: #263D78;
  border-radius: 10px;
  cursor:pointer;
} */

</style>